import React from 'react';
import DocSection from "./DocSection";
import {Alert, Breadcrumb} from "flowbite-react";
import {HiHome, HiInformationCircle} from "react-icons/hi";
import {IoDocumentText} from "react-icons/io5";

const ExtraFeaturesDoc = () => {
    const serverUrl = process.env.REACT_APP_SERVER_URL;
    const formyForm = `<script src="${window.location.origin}/assets/js/captcha.min.js" type="module"></script>

<altcha-widget challengeurl="${serverUrl}/captcha"></altcha-widget>
`;

    return (
        <section className="bg-white dark:bg-gray-700">
            <Breadcrumb aria-label="Breadcrumb navigation" className="bg-gray-100 px-5 py-3 dark:bg-gray-900">
                <Breadcrumb.Item href="/" icon={HiHome}>Home</Breadcrumb.Item>
                <Breadcrumb.Item href="/documentation" icon={IoDocumentText}>Documentation</Breadcrumb.Item>
                <Breadcrumb.Item>
                    <span className="text-gray-900 dark:text-white">Extra Features</span>
                </Breadcrumb.Item>
            </Breadcrumb>

            <div className="mx-auto max-w-screen-md text-center my-8">
                <h1 className="text-4xl font-extrabold text-gray-900 dark:text-white">
                    Extra Features
                </h1>
                <p className="mt-2 text-lg text-gray-700 dark:text-gray-300">
                    Discover how extra features can enhance your forms
                </p>
            </div>

            <div className="mx-auto max-w-screen-lg pb-8">
                <DocSection
                    title="Captcha"
                    description="Enhance your form security by integrating a captcha. To enable captcha verification,
                    include the following script in your site and use the captcha widget as shown in the example below."
                    examples={[formyForm]}
                    alert={{ color: "failure", message: "Do not modify the challengeurl." }}
                />
                <Alert color="info" icon={HiInformationCircle} className="mt-4">
                    We use <a href="https://altcha.org" className="underline" target="_blank" rel="noopener noreferrer">Altcha</a>,
                    a self-hosted, open-source CAPTCHA solution, to prevent spam and automated submissions.
                    You can customize its behavior through <a href="https://altcha.org/docs/website-integration/#configuration" className="underline" target="_blank" rel="noopener noreferrer">Altcha's configuration options</a>.
                </Alert>
                <h2 className="text-2xl text-gray-700 dark:text-gray-300 mt-8 mb-4">
                    Hidden Inputs:
                </h2>
                <DocSection
                    title="_subject"
                    description="This input field sets the subject line."
                    examples={[
                        "<input type=\"hidden\" name=\"_subject\" value=\"Custom Subject!\">"
                    ]}
                />
                <DocSection
                    title="_cc"
                    description="This input field is used for the CC field, allowing you to send a copy of each submission to additional recipients."
                    examples={[
                        "<input type=\"hidden\" name=\"_cc\" value=\"FIRST_TOKEN\">",
                        "<input type=\"hidden\" name=\"_cc\" value=\"FIRST_TOKEN,SECOND_TOKEN\">",
                    ]}
                    alert={{ color: "failure", message: "Maximum allowed values is 2. Additional tokens will be ignored." }}
                />
                <DocSection
                    title="_next"
                    description="This input field specifies the URL of a custom 'Thank You' page. By default, Formy redirects users to a standard 'Thank You' page after form submission."
                    examples={[
                        "<input type=\"hidden\" name=\"_next\" value=\"https://abolfazlmohajeri.ir\">"
                    ]}
                    alert={{ color: "failure", message: "This feature is not compatible with AJAX requests." }}
                />
            </div>
        </section>
    );
};

export default ExtraFeaturesDoc;
